const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-TEST-RESULT-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-TEST-RESULT-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-TEST-RESULT-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-TEST-RESULT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-TEST-RESULT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
